<template>
  <div>
    <!-- 新着作品(ボイス) -->
    <v-sheet min-height="176">
      <section class="mt-8 mb-2 d-flex justify-space-between">
        <h1 class="fs-l">新着ボイス</h1>

        <v-btn
          text
          small
          :to="{ name: 'voice' }"
          class="fs-xs fc-gray-6 font-weight-medium"
        >
          一覧で見る
          <v-icon small>chevron_right</v-icon>
        </v-btn>
      </section>
      <GalleryVoiceList :voiceList="voiceListView" />
    </v-sheet>

    <!-- 新着作品(ノベル) -->
    <section class="mt-8 mb-2 d-flex justify-space-between">
      <h1 class="fs-l">新着ノベル</h1>

      <v-btn
        text
        small
        :to="{ name: 'novel' }"
        class="fs-xs fc-gray-6 font-weight-medium"
      >
        一覧で見る
        <v-icon small>chevron_right</v-icon>
      </v-btn>
    </section>

    <GalleryNovelList :novelList="novelListView" />

    <!-- 新着作品(イラスト) -->
    <section class="my-8">
      <h1 class="fs-l">新着イラスト</h1>

      <GalleryIllustList :illustList="dataLists"></GalleryIllustList>
      <infinite-loading
        ref="infiniteLoading"
        spinner="waveDots"
        @infinite="infiniteLoad"
      >
        <span slot="no-more">
          <v-img
            :src="`${assetsPath}/p/img/alpaca.png`"
            width="64"
            class="mx-auto my-4"
            style="opacity: 0.8;"
        /></span>
        <span slot="no-results"> 検索結果はありません</span>
      </infinite-loading>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import GalleryIllustList from "@/views/tailor/galleryIllustList";
import GalleryNovelList from "@/views/tailor/galleryNovelList";
import GalleryVoiceList from "@/views/tailor/galleryVoiceList";
import InfiniteLoading from "vue-infinite-loading";

export default {
  components: {
    GalleryIllustList,
    GalleryNovelList,
    GalleryVoiceList,
    InfiniteLoading,
  },
  name: "gallery",
  data() {
    return {
      userId: "",
      dataLists: [],
      illustList: [],
      novelList: [],
      voiceList: [],
      creatorId: "",
      illustitemCount: 0,
      perPage: 24,
      perPageVoice: 16,
      perPageNovel: 12,
      page: 1,
      pageVoice: 1,
      pageNovel: 1,
      voiceIndex: "",
      hyoukasuuShouhin: "",
      count: "",
      disableReview: false,
      timer: "",
      selectedSakuhin: "",
      selectedWorld: "",
      selectedShouhin: "",
      sakuhinOptions: [
        {
          value: "",
          label: "全ての作品",
        },
      ],
      worldOptions: [
        {
          value: "",
          label: "全てのワールド",
        },
      ],
      shouhinOptions: [
        {
          value: "",
          label: "全ての商品",
        },
        {
          value: "1",
          label: "イラスト",
        },
        {
          value: "2",
          label: "ボイス",
        },
        {
          value: "3",
          label: "ノベル",
        },
      ],
      voicePageStart: "0",
      voicePageEnd: "10",
      voiceInfoLists: [],
      showVoiceInfoLists: [],
      voiceInfoList: "",
      textPageStart: "0",
      textPageEnd: "9",
      textInfoLists: [],
      showTextInfoLists: [],
      textInfoList: "",
      showDuration: false,
      noselect: false,
      noselectVoice: false,
      noselectNovel: false,

      loading: false,
    };
  },
  props: ["portal"],

  created: async function () {
    this.loading = true;
    this.userId = this.$store.state.userId;

    // ボイスリストをGET
    this.getVoiceInfo();

    // ノベルリストをGET
    this.getTextInfo();

    this.loading = false;
  },

  computed: {
    voiceListView() {
      let arr = this.voiceList;
      if (this.$vuetify.breakpoint.xsOnly) {
        arr = arr.slice(0, 6);
      }
      return arr;
    },
    novelListView() {
      let arr = this.novelList;
      if (this.$vuetify.breakpoint.xsOnly) {
        arr = arr.slice(0, 6);
      }
      return arr;
    },
  },
  watch: {
    showVoiceInfoLists() {
      this.$nextTick(function () {
        this.showDuration = true;
      });
    },
  },

  methods: {
    // 画像の読み込み
    infiniteLoad: async function () {
      var pageStart = this.illustitemCount;
      var pageEnd = this.perPage;
      await axios
        .get(
          this.serverPath +
            "/api/Tailor/ShowOrderGoods?pageStart=" +
            pageStart +
            "&pageEnd=" +
            pageEnd +
            "&nouhinzumiFlg=1" +
            "&hachuJoutai=0" +
            "&shouhinShubetsu=1"
        )
        .then((response) => {
          for (var i = 0; i < response.data.length; i++) {
            this.dataLists.push(response.data[i]);
          }
          this.illustitemCount += this.perPage;
          if (response.data.length == this.perPage) {
            this.$refs.infiniteLoading.stateChanger.loaded();
          } else {
            this.$refs.infiniteLoading.stateChanger.complete();
          }
          setTimeout(this.$redrawVueMasonry, 1000);
        })
        //接続エラー
        .catch((error) => {
          console.log(error);
        });
    },

    changeWidth() {
      setTimeout(this.$redrawVueMasonry, 500);
    },

    // ボイスリストをGET
    getVoiceInfo: async function () {
      if (this.noselectVoice == false) {
        // console.log("受注情報をGETzoule");
        var pageStart =
          parseInt(this.pageVoice) * this.perPageVoice - this.perPageVoice;
        const res = await axios.get(
          this.serverPath +
            "/api/Tailor/ShowOrderGoodsGalleryVoice?pageStart=" +
            pageStart +
            "&pageEnd=" +
            this.perPageVoice
        );
        if (this.pageVoice == 1) {
          this.voiceList = res.data;
        } else {
          var rs = [];
          rs = res.data;
          var voiceInfoLists = this.voiceInfoLists;
          for (var i = 0; i < rs.length; i++) {
            voiceInfoLists.push(rs[i]);
          }
          this.voiceInfoLists = voiceInfoLists;
        }
        //ページャー単ページー表示数の処理
        if (res.data.length < this.perPageVoice) {
          this.noselectVoice = true;
        }
      }
    },

    // ノベルリストをGET
    getTextInfo: async function () {
      if (this.noselectNovel == false) {
        // console.log("受注情報をGETzoule");
        var pageStart = 0;
        const res = await axios.get(
          this.serverPath +
            "/api/Tailor/ShowOrderGoodsGalleryNovel?pageStart=" +
            pageStart +
            "&pageEnd=" +
            this.perPageNovel
        );
        if (this.pageNovel == 1) {
          // console.log("this.page==1");
          this.textInfoLists = res.data;
          this.novelList = res.data;
        } else {
          // console.log("!this.page==1");
          var rs = [];
          rs = res.data;
          // console.log("rs.length" + rs.length);
          var textInfoLists = this.textInfoLists;
          // console.log("old textInfoLists" + textInfoLists.length);
          // this.dataLists= imgList.concat(rs);
          for (var i = 0; i < rs.length; i++) {
            textInfoLists.push(rs[i]);
          }
          this.textInfoLists = textInfoLists;
          // console.log("concat textInfoLists" + textInfoLists.length);
          //this.dataLists = imgList;
          // console.log("this.textInfoLists.length" + this.textInfoLists.length);
        }
        //ページャー単ページー表示数の処理
        if (res.data.length < this.perPageNovel) {
          this.noselectNovel = true;
        }
      }
    },

    //納品一覧リストをGET
    getImageData: async function () {
      if (this.noselect == false) {
        // console.log("20200302納品一覧リストをGETzoule");
        var pageStart = parseInt(this.page) * this.perPage - this.perPage;
        var pageEnd = parseInt(this.perPage);
        // console.log("請求写真startとend=" + pageStart + "/" + pageEnd);
        const res = await axios.get(
          this.serverPath +
            "/api/Tailor/ShowOrderGoods?pageStart=" +
            pageStart +
            "&pageEnd=" +
            pageEnd +
            "&nouhinzumiFlg=1" +
            "&hachuJoutai=0" +
            "&shouhinShubetsu=1"
        );

        if (this.page == 1 || !this.dataLists) {
          // console.log("this.page==1");
          this.dataLists = res.data;
          var rs = null;
        } else {
          // console.log("!this.page==1");
          this.illustList = res.data;
          var rs = [];
          rs = res.data;
          // console.log("rs.length" + rs.length);

          // var dataLists = [];
          // if (this.dataLists) {
          //   dataLists = this.dataLists;
          // }
        }
        //ページャー単ページー表示数の処理
        if (res.data.length < this.perPage) {
          this.noselect = true;
          // console.log(
          //   "ページャー単ページー表示数の処理" + this.page + this.noselect
          // );
        } else {
          // console.log(
          //   "ページャー単ページー表示数の処理" + this.page + this.noselect
          // );
        }
      } else {
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/sass/import.scss";

.gIl {
  margin-right: -16px;
  margin-left: -16px;
  // &-Loader {
  //   display: grid;
  //   gap: 32px;
  //   grid-template-columns: repeat(2, 1fr);
  //   @include media($sm) {
  //     grid-template-columns: repeat(4, 1fr);
  //   }
  //   @include media($md) {
  //     grid-template-columns: repeat(5, 1fr);
  //   }
  //   @include media($lg) {
  //     grid-template-columns: repeat(6, 1fr);
  //   }
  // }
}
</style>
